import Header from '../feature/Header';
import Footer from '../feature/Footer';
import { Outlet, useLocation } from 'react-router-dom';

const MainLayout = () => {
  const location = useLocation();
  return (
    <>
      <Header />
      <main className={`public-main ${location.pathname === '/' ? 'pt-0' : 'pt-20'}`}>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default MainLayout;
